// extracted by mini-css-extract-plugin
module.exports = {"discoverCard":"DiscoverCard_discoverCard__zLDKN","backgroundMediaWrapper":"DiscoverCard_backgroundMediaWrapper__l3ryq","headingWrapper":"DiscoverCard_headingWrapper__2RscR"};